var scope_0 = require('/home/naveed/Desktop/learnfp/learn-fp/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/70b54b478aa2347ce099ac5842d1a996.js').default;
var scope_1 = require('/home/naveed/Desktop/learnfp/learn-fp/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    